import { Container, Modal } from "./styles";
import ScrollAnimation from "react-animate-on-scroll";
import { useState } from "react";
import certificateImg from "../../assets/certificate.png";
import letterPdf from "../../assets/Letter of Recommendation.pdf";

export function Experience() {
  const [modalContent, setModalContent] = useState<{ type: 'image' | 'pdf' | null; src: string; title: string }>({ type: null, src: '', title: '' });

  const openModal = (type: 'image' | 'pdf', src: string, title: string) => {
    setModalContent({ type, src, title });
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setModalContent({ type: null, src: '', title: '' });
    document.body.style.overflow = 'unset';
  };

  return (
    <Container id="experience">
      <h2>Experience</h2>
      <div className="experience-timeline">
        <ScrollAnimation animateIn="fadeInLeft" delay={0.1 * 1000}>
          <div className="experience-card">
            <div className="experience-icon">
              <img src="/Images/capgemini.png" alt="Capgemini" className="company-logo" />
            </div>
            <div className="experience-content">
              <div className="experience-header">
                <h3>GenAI Engineer</h3>
                <span className="company">Capgemini</span>
              </div>
              <span className="duration">Jun 2025 - Present</span>
              <p>
                Working on cutting-edge generative AI solutions that help businesses 
                leverage the power of large language models and AI technologies. 
                Building innovative solutions that transform how organizations 
                interact with and utilize artificial intelligence.
              </p>
              <div className="skills-tags">
                <span>Generative AI</span>
                <span>LLMs</span>
                <span>Machine Learning</span>
                <span>Python</span>
                <span>AutoGen</span>
                <span>LangChain</span>
                <span>Azure</span>
                <span>SQL</span>
                <span>Next.js</span>
              </div>
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="fadeInRight" delay={0.2 * 1000}>
          <div className="experience-card">
            <div className="experience-icon">
              <img src="/Images/microsoft.png" alt="Microsoft" className="company-logo" />
            </div>
            <div className="experience-content">
              <div className="experience-header">
                <h3>Gold Microsoft Student Ambassador</h3>
                <span className="company">Microsoft</span>
              </div>
              <span className="duration">Jul 2023 - Jun 2025</span>
              <p>
                Led technical workshops, mentored students, and built vibrant tech 
                communities focused on cloud technologies and innovation. Helped 
                fellow students learn new technologies and develop their career 
                skills for the future through engaging events and educational sessions.
              </p>
              <div className="skills-tags">
                <span>Azure</span>
                <span>Cloud Computing</span>
                <span>Community Building</span>
                <span>Technical Workshops</span>
              </div>
              <div className="documents">
                <button 
                  onClick={() => openModal('image', certificateImg, 'MLSA Certificate')}
                  className="doc-link highlight"
                >
                  <span className="doc-icon">🏆</span>
                  <span className="doc-text">Certificate</span>
                  <span className="shine"></span>
                </button>
                <button 
                  onClick={() => openModal('pdf', letterPdf, 'Letter of Recommendation')}
                  className="doc-link highlight"
                >
                  <span className="doc-icon">📄</span>
                  <span className="doc-text">Letter of Recommendation</span>
                  <span className="shine"></span>
                </button>
              </div>
            </div>
          </div>
        </ScrollAnimation>
      </div>

      {modalContent.type && (
        <Modal onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>{modalContent.title}</h3>
              <button className="close-btn" onClick={closeModal}>
                <span>×</span>
              </button>
            </div>
            <div className="modal-body">
              {modalContent.type === 'image' ? (
                <img src={modalContent.src} alt={modalContent.title} />
              ) : (
                <iframe src={modalContent.src} title={modalContent.title} />
              )}
            </div>
          </div>
        </Modal>
      )}
    </Container>
  );
}
